import axios from "axios";
import moment from "moment";
import modelEmployed from "../../models/gestionTiempos/settlementModel/modelEmployed";
import modelGroup from "../../models/gestionTiempos/settlementModel/modelGroup";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  new = (data) => {
    let token = localStorage.getItem("token");
    let empId = parseInt(localStorage.getItem("empId"), 10);
    let operId = parseInt(localStorage.getItem("operId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;
    if (data.to) {
      payload = {
        operId: operId,
        empId: empId,
        fecha: data.date + "T00:00:00.000Z",
        liqModeloId: data.model,
        fecDesde: data.from + "T00:00:00.000Z",
        fecHasta: moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      };
    } else {
      payload = {
        operId: operId,
        empId: empId,
        fecha: data.date + "T00:00:00.000Z",
        liqModeloId: data.model,
        fecDesde: data.from + "T00:00:00.000Z",
      };
    }

    return axios.post(`${url}/empmodelos`, payload, { headers });
  };
  getModelEmployed = () => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const empId = localStorage.getItem("empId");
    return axios
      .get(`${url}/empmodelos/${empId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return modelEmployed.fromJson(item);
        })
      );
  };
  getModelGroup = () => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const empId = localStorage.getItem("empId");
    return axios
      .get(`${url}/empmodelos/grupos/${empId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return modelGroup.fromJson(item);
        })
      );
  };
  edit = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const empId = localStorage.getItem("empId");
    let desde = data.fromOld + "T00:00:00.000Z";
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      fecha: data.date + "T00:00:00.000Z",
      fecDesde: data.from + "T00:00:00.000Z",
    };
    if (data.haNoEx) {
      payload = {
        ...payload,
        haNoEx: data.haNoEx,
      };
    } else if (data.to && !data.haNoEx) {
      payload = {
        ...payload,
        fecHasta: moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      };
    }

    return axios
      .patch(`${url}/empmodelos/${empId}&${data.nameId}&${desde}`, payload, {
        headers,
      })
      .then(() => {});
  };
  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const empId = localStorage.getItem("empId");
    let liqModeloId = data.id;
    let desde = data.from;

    return axios.delete(`${url}/empmodelos/${empId}&${liqModeloId}&${desde}`, {
      headers,
    });
  };
}
export default service;
